<script>
import RegisterEmployeeView from "@/pages/guard/RegisterEmployeeView.vue";
import {getInviteVisitorFormSetting} from "@/api/setting-api";
import RegisterVisitorView from "@/pages/guard/RegisterVisitorView.vue";
import RegisterFormView from "@/pages/guard/RegisterFormView.vue";
import {signEnterBatch, signLeaveBatch} from "@/api/record-api";
import MyNotifyDialog from "@/components/MyNotifyDialog.vue";
import {guardApplyAdd} from "@/api/apply-api";
import {aesEnc} from "@/utils/cryptoUtils";
import PrintView from "@/pages/guard/PrintView.vue";
import {usual_visitor_sign_mixin} from "@/pages/helper/usual_visitor_mixin";
import {getSettingItem} from "@/api/setting-api";

export default {
  name: "VisitorRegisterPage",
  components: {PrintView, MyNotifyDialog, RegisterFormView, RegisterVisitorView, RegisterEmployeeView},
  mixins: [usual_visitor_sign_mixin],
  data() {
    return {
      topTag: {
        show: true,
        text: "现场登记", // 员工邀约/现场登记/自助登记/常访签到
      },

      employee: null,

      visitorSetting: {
        idCardNo: 2, // 身份证号设置  1不展示， 2选填， 3必填; 默认选填
        nationality: 1, // 国籍设置  1不展示， 2选填， 3必填； 默认不展示
      },

      guardSignConfig: 3, // 保安签名配置 1=不展示, 2=选填, 3=必填; 默认必填

      submitBtnType: "register", // register , leave, enter
      submitBtnName: "登记",
      addBtnDisable: false,

      curRecord: null,
      curApply: null,
      curVisitor: null,

      notify: {title: "", show: false, success: false, msg: ""},

      printInfo: {
        visitorName: "",
        visitorCount: 1,
        visitorCompany: "",
        visitorPhone: "",
        visitorReason: "",
        visitorCarNo: "",
        visitorCountry: "",
        enterArea: "",
        employeeDepartment: "",
        employeeName: "",
        enterTime: "",
        leaveTime: "",
        employeeSign: "",
        guardSign: "",
        qrCode: "",
        visitorCardNo: "",
        isProvider: false,
        saveArea: "", // 存放区域， 填卡号
      },

      mainButtonLoading: false,
    }
  },

  mounted() {
    let params = this.$route.params
    if (params && params.apply) {
      this.$refs.visitorFormView.doChooseApply(params.apply)
    }

    // 加载保安签名配置
    this.loadGuardSignConfig()

    // TODO: 保安助手需求来时修改
    getInviteVisitorFormSetting().then(({data}) => {
      console.log("getInviteVisitorFormSetting", data)
      if (data.code === 200) {
        data.data.forEach(item => {
          if (item.type === "VISITOR_INVITE") {
            let content = JSON.parse(item.content)
            if (content) {
              this.visitorSetting = {
                idCardNo: content.idCardNo,
                nationality: content.nationality
              }
            }
          }
        })
      }
    }).catch((err) => {
      console.log(err)
    })
  },

  methods: {
    onSubmitBtnClick() {
      if (this.mainButtonLoading) {
        return
      }
      this.mainButtonLoading = true

      this.$refs.employeeView.checkEmployeeLandline()
      switch (this.submitBtnType) {
        case "register":
          this.doVisitorRegister()
          break;
        case "leave":
          this.doVisitorSignLeave()
          break;
        case "enter":
          this.doVisitorSignEnter()
          break;
        default:
          console.log("err: submitBtnType" + this.submitBtnType)
          this.mainButtonLoading = false
          break
      }
    },


    loadGuardSignConfig() {
      getSettingItem("MANAGE", "GUARD_SIGN_SETTING").then(({data}) => {
        if (data.code === 200 && data.data && data.data.length > 0) {
          let setting = data.data[0]
          if (setting.content) {
            this.guardSignConfig = parseInt(setting.content)
          }
        }
      }).catch(err => {
        console.log("loadGuardSignConfig err", err)
      })
    },

    doVisitorRegister() {
      if (this.employee === null) {
        this.$message.error("请选择被访员工")
        this.mainButtonLoading = false
        return
      }
      let peerList = this.$refs.visitorView.selectVisitorList
      let mainVisitorTel = this.$refs.visitorFormView.visitorForm.tel
      let find = peerList.find(item => item.tel === mainVisitorTel)
      if (find) {
        this.$message.error("主访客与同行人不能重复，请检查")
        this.mainButtonLoading = false
        return
      }

      Promise.all([
        this.$refs.visitorFormView.$refs.visitorForm.validate(),
        this.$refs.visitorFormView.$refs.applyForm.validate(),
        this.$refs.visitorFormView.$refs.extForm.validate(),
      ]).then(() => {
        console.log("doVisitorRegister form check pass")

        this._doVisitorRegister()
      }).catch(err => {
        console.log("doVisitorRegister form check false", err)
        this.mainButtonLoading = false
      })
    },

    async _doVisitorRegister() {
      let mainVisitor = await this.$refs.visitorFormView.getMainVisitor()
      console.log("_doVisitorRegister mainVisitor", mainVisitor)
      if (mainVisitor.type === "black") {
        await this.$alert(`访客：${mainVisitor.name}，手机号：${mainVisitor.tel}，为黑名单访客,无法登记`, "提示", {confirmButtonText: "确定"})
        this.mainButtonLoading = false
        return
      }
      let forms = this.$refs.visitorFormView.getFormItems()
      let formExtInfo = this.$refs.visitorFormView.extFormData
      formExtInfo.enterCardNo = mainVisitor.extCardNo
      let employee = this.employee
      let peerList = this.$refs.visitorView.selectVisitorList
      let signOutTime = this.$refs.visitorFormView.signOutTime

      let accompanyCards = {}
      peerList.forEach(item => {
        if (item.registerCardNo) {
          accompanyCards[item.code] = item.registerCardNo
        }
      })

      let apply = {}
      apply.employeeId = employee.id
      apply.employeeCode = employee.code
      apply.visitorCode = mainVisitor.code
      apply.visitorId = mainVisitor.id
      apply.visitorCardNo = mainVisitor.extCardNo
      apply.type = "SCENE_APPLY"
      apply.accompanies = peerList.map(item => item.code).join('|')
      apply.accompanyCards = accompanyCards
      apply.device = "web"
      apply.checkoutTime = signOutTime
      apply.entryArea = null

      let areaId = this.$store.state.loginInfo.areaId
      if (areaId) {
        apply.entryArea = areaId
      }
      let startTime = new Date()
      let endTime = new Date()

      apply.beginDate = startTime.getFullYear() + "-" + ('0' + (startTime.getMonth() + 1)).slice(-2) + "-" + ('0' + startTime.getDate()).slice(-2)
      apply.endDate = endTime.getFullYear() + "-" + ('0' + (endTime.getMonth() + 1)).slice(-2) + "-" + ('0' + endTime.getDate()).slice(-2)
      apply.beginTime = ('0' + startTime.getHours()).slice(-2) + ":" + ('0' + startTime.getMinutes()).slice(-2) + ":" + ('0' + startTime.getSeconds()).slice(-2)
      apply.endTime = ('0' + endTime.getHours()).slice(-2) + ":" + ('0' + endTime.getMinutes()).slice(-2) + ":" + ('0' + endTime.getSeconds()).slice(-2)
      apply.forms = forms

      guardApplyAdd(apply).then(({data}) => {
        if (data.code === 200) {
          this.doOnAddApplySuccess(apply, data.data, formExtInfo)
        } else {
          console.warn("addApply false", data.code, data.msg)
          this.showServerErrMsg(data.code)
        }
        this.mainButtonLoading = false
      }).catch(err => {
        console.error("addApply err", err)
        this.showNetErrMsg()
        this.mainButtonLoading = false
      })
    },

    doOnAddApplySuccess(postApplyData, applyResult, extInfo) {
      this.preparePrintMsg(postApplyData)
      if (applyResult.state === "PASS") {
        this.doSignEnterAfterRegist(applyResult, extInfo)
      } else {
        this.notify = {title: "登记结果", show: true, success: true, msg: "登记成功",}
        this.startAutoCloseTimer()
      }
    },

    startAutoCloseTimer() {
      if (this.autoCloseTimer) {
        clearTimeout(this.autoCloseTimer)
      }
      this.autoCloseTimer = setTimeout(() => {
        this.autoCloseTimer = null
        this.onDialogClose()
      }, 2000)
    },


    doSignEnterAfterRegist(applyInfo, extInfo) {
      console.log("@@@ doSignEnterAfterRegist", applyInfo, extInfo)

      let applyId = applyInfo.id
      let enterAreaId = this.$store.state.loginInfo.areaId
      let enterGuardName = extInfo.guardSign
      let enterCardNos = applyInfo.accompanyCards
      let visitorCodes = applyInfo.accompanies ? applyInfo.accompanies.split('|') : []
      // applyInfo.visitor.code 插入到开头
      visitorCodes.unshift(applyInfo.visitor.code)

      if (extInfo.enterCardNo) {
        enterCardNos[applyInfo.visitor.code] = extInfo.enterCardNo
      }

      let enterCarNum = extInfo.enterCarNum
      let comments = extInfo.comments
      let postData = {applyId, visitorCodes, enterCarNum, enterCardNos, enterAreaId, enterGuardName, comments}

      console.log("@@@ doSignEnterAfterRegist postData", postData)
      signEnterBatch(postData).then(({data}) => {
        console.log("signEnter", data)
        if (data.code === 200) {
          this.notify = {title: "签到结果", show: true, success: true, msg: "签到成功"}
          this.startAutoCloseTimer()
          this.printInfo.qrCode = data.data[0].pinCode
          this.printInfo.visitorCount = visitorCodes.length
          this.printInfo.saveArea = extInfo.enterCardNo
          if (!this.printInfo.saveArea && enterCardNos.size > 0) {
            for (let key in enterCardNos) {
              if (enterCardNos[key]) {
                this.printInfo.saveArea = enterCardNos[key]
                break;
              }
            }
          }
          this.$refs.printView.setPrintInfo(this.printInfo)
          setTimeout(() => {
            this.doPrint()
          }, 200)
        } else {
          this.notify = {title: "登记结果", show: true, success: false, msg: "登记成功"}
          this.startAutoCloseTimer()
          this.logE("VisitCodeCome signEnter false", data.code, data.msg)
        }
        this.autoCloseTimer = setTimeout(() => {
          this.autoCloseTimer = null
          this.onDialogClose()
        }, 2000)
      }).catch((err) => {
        this.logE("VisitCodeCome signEnter err", err)
        this.notify = {title: "登记结果", show: true, success: true, msg: "登记成功",}
        this.startAutoCloseTimer()
      })
    },

    onDialogClose() {
      this.resetAll()
    },

    preparePrintMsg(apply) {
      console.log("preparePrintMsg", apply)
      let reason = ""
      let carNum = ""
      if (apply.forms) {
        apply.forms.forEach(item => {
          if (item.name === "reason") {
            reason = item.value
          }
          if (item.name === "carNumber") {
            carNum = item.value
          }
        })
      }
      let visitor = this.$refs.visitorFormView.visitor

      let now = new Date()
      let enterTime = now.getFullYear() + "-" + (now.getMonth() + 1) + "-" + now.getDate() + " " + now.getHours() + ":" + now.getMinutes()
      // let msg = {type: "visitor", code: visitor.code}
      // let qrCodeStr = aesEnc(JSON.stringify(msg))

      let employee = this.employee

      this.printInfo.visitorName = visitor.name
      this.printInfo.visitorCount = this.$refs.visitorFormView.extFormData.visitorCount
      this.printInfo.visitorCompany = visitor.company
      this.printInfo.visitorPhone = visitor.tel
      this.printInfo.visitorReason = reason
      this.printInfo.visitorCarNo = carNum
      this.printInfo.visitorCountry = visitor.nationality
      this.printInfo.isProvider = visitor.type === 'provider'
      this.printInfo.visitorCardNo = apply.visitorCardNo

      this.printInfo.guardSign = ""
      this.printInfo.employeeName = employee.name
      this.printInfo.employeeDepartment = employee.departmentName
      this.printInfo.employeeSign = ""

      this.printInfo.enterArea = ""
      this.printInfo.enterTime = enterTime
      this.printInfo.leaveTime = ""
      // this.printInfo.qrCode = qrCodeStr
    },

    doVisitorSignEnter() {
      let guardSign = this.$refs.visitorFormView.extFormData.guardSign
      if (this.guardSignConfig === 3 && !guardSign) {
        this.$message.error("请选择保安签名")
        this.mainButtonLoading = false
        return
      }
      if (this.curApply) {
        this.applySignEnter()
      } else {
        // 常访签到
        this.usualVisitorSignEnter()
        this.startAutoCloseTimer()
        this.mainButtonLoading = false
      }
    },

    applySignEnter() {
      let formExtInfo = this.$refs.visitorFormView.extFormData
      let signVisitorList = this.$refs.visitorView.selectVisitorList

      if (signVisitorList.length === 0) {
        this.$message.error("请选择签到的访客")
        this.mainButtonLoading = false
        return
      }

      this._doSignEnter(this.curApply, formExtInfo, signVisitorList)
    },

    _doSignEnter(applyInfo, extraInfo, visitorList) {
      let applyId = applyInfo.id
      let visitorCodes = visitorList.map(item => item.code)
      let enterAreaId = this.$store.state.loginInfo.areaId
      let enterCarNum = extraInfo.enterCarNum
      let comments = extraInfo.comments
      let enterGuardName = extraInfo.guardSign
      let enterCardNos = {}
      visitorList.forEach(item => {
        if (item.registerCardNo)
          enterCardNos[item.code] = item.registerCardNo
      })

      let postData = {applyId, visitorCodes, enterCarNum, enterCardNos, enterAreaId, enterGuardName, comments}
      signEnterBatch(postData).then(({data}) => {
        console.log("signEnter", data)
        if (data.code === 200) {
          this.printInfo.qrCode = data.data[0].pinCode
          this.printInfo.visitorCount = visitorList.length
          this.printInfo.visitorName = visitorList[0].name
          this.printInfo.visitorCardNo = visitorList[0].cardNo
          this.printInfo.isProvider = visitorList[0].type === "provider"
          this.printInfo.saveArea = ""

          for (let i = 0; i < visitorList.length; i++) {
            if (visitorList[i].registerCardNo) {
              this.printInfo.saveArea = visitorList[i].registerCardNo
              break;
            }
          }
          this.$refs.printView.setPrintInfo(this.printInfo)
          setTimeout(() => {
            this.doPrint()
          }, 200)
          this.notify = {title: "签到结果", show: true, success: true, msg: "签到成功"}
          this.startAutoCloseTimer()
          this.autoCloseTimer = setTimeout(() => {
            this.autoCloseTimer = null
            this.onSignDialogClose()
          }, 2000)
        } else {
          this.notify = {title: "签到结果", show: true, success: false, msg: "签到失败"}
          this.autoCloseTimer = setTimeout(() => {
            this.autoCloseTimer = null
            this.onSignDialogClose()
          }, 2000)
          this.logE("VisitCodeCome signEnter false", data.code, data.msg)
        }
        this.mainButtonLoading = false
      }).catch((err) => {
        this.logE("VisitCodeCome signEnter err", err)
        this.notify = {title: "签到结果", show: true, success: false, msg: "签到失败, 网络异常"}
        this.mainButtonLoading = false
      })
    },

    usualVisitorSignEnter() {
      let guardSign = this.$refs.visitorFormView.extFormData.guardSign

      let visitor = this.curVisitor
      let deviceId = ""
      let areaId = this.$store.state.loginInfo.areaId
      let remark = this.$refs.visitorFormView.extFormData.comments
      let imageBase64 = null
      let icCompareResult = null
      let icCompareScore = null
      let enterCarNum = this.$refs.visitorFormView.extFormData.enterCarNum
      let enterCardNo = visitor.cardNo
      let enterGuardName = guardSign
      this.doUsualSignEnter(visitor, deviceId, areaId, remark, imageBase64, icCompareResult,
          icCompareScore, enterCarNum, enterCardNo, enterGuardName)

    },


    doVisitorSignLeave() {
      let guardSign = this.$refs.visitorFormView.extFormData.guardSign
      if (this.guardSignConfig === 3 && !guardSign) {
        this.$message.error("请选择保安签名")
        this.mainButtonLoading = false
        return
      }
      let areaId = this.$store.state.loginInfo.areaId
      if (this.curRecord.type === "USUAL") {
        this.startAutoCloseTimer()
        this.doUsualSignLeave(this.curRecord.visitor, "", areaId, this.curRecord.id)
        this.mainButtonLoading = false
        return
      }

      let signVisitor = this.$refs.visitorView.selectVisitorList
      console.log("@@@ doVisitorSignLeave", signVisitor)
      if (signVisitor.length === 0) {
        this.$message.error("请选择签离的访客")
        this.mainButtonLoading = false
        return
      }
      for (let i = 0; i < signVisitor.length; i++) {
        if (signVisitor[i].arriveState !== "ENTER") {
          this.$message.error("访客" + signVisitor[i].name + "未签到, 无法签离")
          this.mainButtonLoading = false
          return
        }
      }
      this._doSignLeave(this.curRecord, guardSign, signVisitor)
    },

    _doSignLeave(record, leaveGuardName, visitorList) {
      console.log("@@@", "visitorList", visitorList)
      let recordIds = visitorList.map(item => item.recordId)
      let areaId = this.$store.state.loginInfo.areaId
      let postData = {
        recordIds: recordIds,
        leaveAreaId: areaId,
        leaveGuardName: leaveGuardName,
      }
      signLeaveBatch(postData).then(({data}) => {
        console.log("signLeaveBatch", data)
        if (data.code === 200) {
          this.notify = {title: "签离结果", show: true, success: true, msg: "签离成功",}
          this.autoCloseTimer = setTimeout(() => {
            this.autoCloseTimer = null
            this.onSignDialogClose()
          }, 2000)
        } else {
          this.notify = {title: "签离结果", show: true, success: false, msg: "签离失败",}
          this.logE("VisitCodeCome signEnter false", data.code, data.msg)
        }
        this.mainButtonLoading = false
      }).catch((err) => {
        this.logE("VisitCodeCome signEnter err", err)
        this.notify = {title: "签离结果", show: true, success: false, msg: "签离失败, 网络异常",}
        this.mainButtonLoading = false
      })
    },

    onCancelBtnClick() {
      this.resetAll()
    },

    // employee start
    onAddEmployee() {
      this.$refs.employeeView.showAddEmployeeDrawer()
    },

    notifyGetEmployee(employee) {
      this.$refs.employeeView.doUpdateEmployee(employee)
      this.employee = employee
    },

    cleanData() {
      this.$refs.employeeView.doUpdateEmployee(null)
      this.employee = null
    },

    onEmployeeChange(employee) {
      this.employee = employee
    },
    // employee end

    // visitor start
    onAddVisitor() {
      this.$refs.visitorView.onAddVisitor(false)
    },
    onAddMainVisitor() {
      this.$refs.visitorView.onAddVisitor(true)
    },

    onVisitorSelectChange(selectVisitorList) {
      this.$refs.visitorFormView.onVisitorSelectChange(selectVisitorList)
    },

    onGetRecord(record, curVisitor) {
      if (record.type === "USUAL") {
        this.topTag.text = "常访访客"
      } else if (record.apply) {
        switch (record.apply.type) {
          case 'BOOK_APPLY':
            this.topTag.text = "访客预约"
            break
          case 'INVITE_APPLY':
            this.topTag.text = "员工邀约"
            break
          case 'SCENE_APPLY':
            if (record.apply.device === 'web') {
              this.topTag.text = "现场登记"
            } else {
              this.topTag.text = "自助登记"
            }
            break
        }
      }
      this.submitBtnName = "签离"
      this.submitBtnType = "leave"
      this.addBtnDisable = true
      this.curRecord = record
      this.curVisitor = curVisitor
      if (record.employee) {
        this.notifyGetEmployee(record.employee)
      }
      this.$refs.visitorView.onGetRecord(record, curVisitor)

    },

    async onGetUsualVisitor(visitor) {
      console.log("onGetUsualVisitor", visitor)
      this.topTag = {
        show: true,
        text: "常访签到",
      }
      this.submitBtnName = "签到"
      this.submitBtnType = "enter"
      this.addBtnDisable = true
      this.curVisitor = visitor
      await this.$refs.employeeView.getEmployeeCode(visitor.contactEmployeeCode)
      this.setupUsualVisitorPrintInfo(visitor, this.employee)
    },
    setupUsualVisitorPrintInfo(visitor, employee) {
      let reason = ""
      let now = new Date()
      let enterTime = now.getFullYear() + "-" + (now.getMonth() + 1) + "-" + now.getDate() + " " + now.getHours() + ":" + now.getMinutes()
      let msg = {type: "visitor", code: visitor.code}
      let qrCodeStr = aesEnc(JSON.stringify(msg))
      this.printInfo.visitorName = visitor.name
      this.printInfo.visitorCount = this.$refs.visitorFormView.extFormData.visitorNumber
      this.printInfo.visitorCompany = visitor.company
      this.printInfo.visitorPhone = visitor.tel
      this.printInfo.visitorReason = reason
      this.printInfo.visitorCarNo = visitor.car
      this.printInfo.visitorCountry = visitor.nationality
      this.printInfo.isProvider = visitor.type === "provider"
      this.printInfo.visitorCardNo = visitor.cardNo

      this.printInfo.guardSign = ""
      this.printInfo.employeeName = employee ? employee.name : ""
      this.printInfo.employeeDepartment = employee ? employee.departmentName : ""
      this.printInfo.employeeSign = ""

      this.printInfo.enterArea = ""
      this.printInfo.enterTime = enterTime
      this.printInfo.leaveTime = ""
      this.printInfo.qrCode = qrCodeStr
      this.printInfo.saveArea = visitor.cardNo
      this.$refs.printView.setPrintInfo(this.printInfo)
    },

    onGetApply(apply, curVisitor) {
      switch (apply.type) {
        case 'BOOK_APPLY':
          this.topTag.text = "访客预约"
          break
        case 'INVITE_APPLY':
          this.topTag.text = "员工邀约"
          break
        case 'SCENE_APPLY':
          if (apply.device === 'web') {
            this.topTag.text = "现场登记"
          } else {
            this.topTag.text = "自助登记"
          }
          break
        case 'USUAL':
          this.topTag.text = "常访访客"
          break
      }
      this.submitBtnName = "签到"
      this.submitBtnType = "enter"
      this.addBtnDisable = true
      this.curApply = apply
      this.curVisitor = curVisitor
      this.notifyGetEmployee(apply.employee)
      this.$refs.visitorView.onGetApply(apply, curVisitor)
      this.setupPrintInfo(apply, curVisitor, apply.employee)
    },
    onGetHistory(record, curVisitor) {
      this.notifyGetEmployee(record.employee)
      this.$refs.visitorView.onGetHistory(record, curVisitor)
    },

    setupPrintInfo(apply, visitor, employee) {
      let reason = apply.reason
      if (apply.forms) {
        apply.forms.forEach(item => {
          if (item.name === "reason") {
            reason = item.value
          }
        })
      }
      let now = new Date()
      let enterTime = now.getFullYear() + "-" + (now.getMonth() + 1) + "-" + now.getDate() + " " + now.getHours() + ":" + now.getMinutes()
      this.printInfo.visitorName = visitor.name
      this.printInfo.visitorCount = this.$refs.visitorFormView.extFormData.visitorCount
      this.printInfo.visitorCompany = visitor.company
      this.printInfo.visitorPhone = visitor.tel
      this.printInfo.visitorReason = reason
      this.printInfo.visitorCarNo = this.$refs.visitorFormView.extFormData.enterCarNum
      this.printInfo.visitorCountry = visitor.nationality

      this.printInfo.guardSign = ""
      this.printInfo.employeeName = employee.name
      this.printInfo.employeeDepartment = employee.departmentName
      this.printInfo.employeeSign = ""

      this.printInfo.enterArea = ""
      this.printInfo.enterTime = enterTime
      this.printInfo.leaveTime = ""
      this.printInfo.qrCode = ""
    },
    // visitor end

    onSignDialogClose() {
      this.notify = {title: "", show: false, success: true, msg: "",}
      this.resetAll();
    },
    resetAll() {
      if (this.autoCloseTimer) {
        clearTimeout(this.autoCloseTimer)
        this.autoCloseTimer = null
      }
      this.reset()
      this.$refs.visitorView.reset()
      this.$refs.visitorFormView.reset()
      this.$refs.employeeView.reset()
    },

    reset() {
      this.topTag = {show: true, text: "现场登记"}
      this.notify.show = false
      this.employee = null
      this.submitBtnType = "register"
      this.submitBtnName = "登记"
      this.addBtnDisable = false

      this.curRecord = null
      this.curApply = null
      this.curVisitor = null
    },

    doPrint() {
      this.$refs.printView.startPrint()
    },
  },
}
</script>

<template>
  <div>
    <div class="sign-type mb-2">
      <el-tag effect="dark" type="danger" v-if="topTag.show">{{ topTag.text }}</el-tag>
    </div>
    <div>
      <div class="h-16-left flex flex-row ">
        <div class="w-2/5 flex flex-col pr-4">
          <div class="size-full border-2 border-gray-100">
            <div class="h-10 bg-sky-400 text-white w-full px-6 text-xl font-semibold	py-1 flex items-center">访客信息</div>
            <RegisterFormView ref="visitorFormView" :visitor-setting="visitorSetting" :guard-sign-config="guardSignConfig" @onGetRecord="onGetRecord" @onGetApply="onGetApply" @onGetHistory="onGetHistory" @onGetUsualVisitor="onGetUsualVisitor"></RegisterFormView>
          </div>
        </div>
        <div class="w-3/5 flex flex-col items-center justify-start pr-4">
          <div class="h-40  text-white w-full border-2 border-gray-100 mb-4 ">
            <div class="h-10 bg-sky-400 text-white w-full px-6 text-xl	font-semibold py-1 mr-2 flex justify-between items-center">
              <div>被访人信息</div>
              <el-button plain type="danger" size="mini" @click="onAddEmployee" :disabled="addBtnDisable">添加员工</el-button>
            </div>
            <RegisterEmployeeView ref="employeeView" @employeeChange="onEmployeeChange"></RegisterEmployeeView>

          </div>
          <div class=" text-white w-full   border-2 border-gray-100 grow ">
            <div class="h-10 bg-sky-400 text-white w-full px-6  text-xl	font-semibold	py-1 mr-2 flex justify-between items-center">
              <div>访客信息</div>
              <el-button plain type="danger" size="mini" @click="onAddVisitor" :disabled="addBtnDisable">添加同行人</el-button>
            </div>
            <RegisterVisitorView class="my-height" ref="visitorView" :visitor-setting="visitorSetting" @visitorSelectChange="onVisitorSelectChange"></RegisterVisitorView>
          </div>
        </div>

      </div>
      <div class=" h-16 flex items-center justify-center">
        <el-button class="w-40" type="primary" @click="onSubmitBtnClick" :loading="mainButtonLoading">{{ submitBtnName }}</el-button>
        <el-button class="w-40" @click="onCancelBtnClick">取消</el-button>
      </div>
    </div>

    <my-notify-dialog :show="notify.show" :success="notify.success" :msg="notify.msg" :title="notify.title" @dialogClose="onSignDialogClose"></my-notify-dialog>
    <PrintView ref="printView"/>
  </div>
</template>

<style scoped lang="less">

.sign-type {
  .el-tag {
    font-size: 20px;
  }
}

.el-button {
  font-size: 20px;
}

.text-18 {
  font-size: 18px;
}

// 高度大于850px的时候才显示滚动条
.my-height {
  max-height: calc(100vh - 450px);
  overflow-y: auto;
}

</style>
